import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import InstanceManager from './components/InstanceManager';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Verificar si hay una sesión existente
    const checkAuth = () => {
      try {
        const token = localStorage.getItem('waengine_token');
        const userData = localStorage.getItem('waengine_user');
        
        if (token === 'authenticated' && userData) {
          const parsedUser = JSON.parse(userData);
          setUser(parsedUser);
          setIsAuthenticated(true);
        }
      } catch (error) {
        console.error('Error al verificar autenticación:', error);
        // Limpiar datos corruptos
        localStorage.removeItem('waengine_token');
        localStorage.removeItem('waengine_user');
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('waengine_token');
    localStorage.removeItem('waengine_user');
    setUser(null);
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="app-container">
        <div className="dashboard-container">
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Cargando WAEngine API Manager...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="app-container">
        <Login onLogin={handleLogin} />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              className: 'toast-success',
            },
            error: {
              className: 'toast-error',
            },
          }}
        />
      </div>
    );
  }

  return (
    <div className="app-container">
      <Router>
        <Routes>
          <Route 
            path="/" 
            element={<Dashboard user={user} onLogout={handleLogout} />} 
          />
          <Route 
            path="/instance/:instanceName" 
            element={<InstanceManager user={user} onLogout={handleLogout} />} 
          />
        </Routes>
      </Router>
      
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            className: 'toast-success',
          },
          error: {
            className: 'toast-error',
          },
        }}
      />
    </div>
  );
}

export default App;
